import gql from 'graphql-tag'

export default gql`
mutation createFreeDay($fields: FreeDayInput!) {
    cashAssist {
        createFreeDay(fields: $fields) {
            id
            name
            date
            day
            cashRegisterId
        }
    }
}`
